import { PdfAction } from '@app/libs/reactPdfJs/store/actions';
import {
  CONTRACT_SETUP_ALL_STATE_CLEAR,
  CONTRACT_SETUP_FIELD__CREATION_CANCEL,
  CONTRACT_SETUP_FIELD_CREATE,
  CONTRACT_SETUP_FIELD_TARGET_CHANGE,
  PDF_CLEAR_ALL_STATE,
} from '@app/store/actionTypes';
import { ContractSetupAction } from '@app/store/contract-setup/actions';

type ContractSetupIsFieldInsertingState = boolean;

const initialState: ContractSetupIsFieldInsertingState = false;

export default function reducer(
  state: ContractSetupIsFieldInsertingState = initialState,
  action: ContractSetupAction | PdfAction
) {
  switch (action.type) {
    case CONTRACT_SETUP_ALL_STATE_CLEAR:
    case CONTRACT_SETUP_FIELD__CREATION_CANCEL:
      return initialState;
    case CONTRACT_SETUP_FIELD_CREATE:
    case PDF_CLEAR_ALL_STATE:
      return initialState;
    case CONTRACT_SETUP_FIELD_TARGET_CHANGE:
      return true;
    default:
      return state;
  }
}
